import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { PoTableColumn } from "@po-ui/ng-components";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class EstoqueListService {
  url = `${environment.API}produtos`;
  urlEstoque = `${environment.API}protheus/estoque`;
  get headers(): HttpHeaders {
    return new HttpHeaders({ authorization: sessionStorage.getItem("token") || "" });
  }

  constructor(private http: HttpClient) {}

  getEstoquesList(filtro: String): Observable<any> {
    return this.http.post(this.url, {
      filter: filtro
    }, { headers: this.headers });
  }

  getEstoque(produto: String): Observable<any> {
    return this.http.get(this.urlEstoque + "/?produtob2=" + produto, { headers: this.headers });
  }




  getColumns(): Array<PoTableColumn> {
    return [
      { property: "codigo", label: "Código", width:"30%" },
      { property: "descricao", label: "Descrição", width:"30%" },
      { property: "un", label: "Un.Medida", width:"8%" },
      { property: "ncm", label: "NCM", width:"20%" },
      { property: "estoque",label: "Qtd.Disponível", width:"10%"}
    ];
  }
}
